const NUMERIC_COMPONENT = /^\d+$/;
const SUFFIX_SEPARATOR = /[-+]/;
/**
 * Componenti numerici di `x.y.z`; il suffisso pre-release/build (`-rc.1`,
 * `+build.7`) è ignorato. `null` se un componente non è un intero.
 */
function parseVersionCore(version) {
    const [core = ''] = version.trim().split(SUFFIX_SEPARATOR);
    const components = core.split('.');
    if (!components.every((component) => NUMERIC_COMPONENT.test(component))) {
        return null;
    }
    return components.map(Number);
}
/**
 * Vero solo se `remote` è più recente di `local` sui componenti numerici
 * (`1.2.10` > `1.2.9`, `1.2.3.1` > `1.2.3`, `1.2.3.0` = `1.2.3`). Il suffisso
 * pre-release/build non conta: `1.2.0-rc.1` e `1.2.0` valgono uguali, così una
 * pre-release non avvisa mai per errore. Una versione illeggibile non è mai
 * più recente: meglio nessun avviso che un avviso a ogni controllo.
 */
export function isNewerVersion(remote, local) {
    const remoteCore = parseVersionCore(remote);
    const localCore = parseVersionCore(local);
    if (!remoteCore || !localCore)
        return false;
    const length = Math.max(remoteCore.length, localCore.length);
    const differingIndex = Array.from({ length }, (_, index) => index).find((index) => (remoteCore[index] ?? 0) !== (localCore[index] ?? 0));
    if (differingIndex === undefined)
        return false;
    return (remoteCore[differingIndex] ?? 0) > (localCore[differingIndex] ?? 0);
}
//# sourceMappingURL=app-version.js.map